export const TODAY = 'Today';
export const SELECT = 'Filter by Date';
export const YESTERDAY = 'Yesterday';
export const THIS_MONTH = 'This month';
export const THIS_QUATER = 'This quarter';
export const THIS_YEAR = 'This year';
export const LAST_QUATER = 'Last quarter';
export const LAST_YEAR = 'Last year';
export const LAST_30_DAYS = 'Last 30 days';
export const LAST_MONTH = 'Last month';
export const CUSTOMIZE = 'Custom';

export const OPTIONS_FOR_DATE_TYPE = [
  TODAY,
  LAST_30_DAYS,
  THIS_MONTH,
  THIS_QUATER,
  THIS_YEAR,
  LAST_MONTH,
  LAST_QUATER,
  LAST_YEAR,
];
export const OPTIONS_FOR_DATE_TYPE_WITHOUT_CUSTOM = [
  TODAY,
  LAST_30_DAYS,
  THIS_MONTH,
  THIS_QUATER,
  THIS_YEAR,
  LAST_MONTH,
  LAST_QUATER,
  LAST_YEAR,
];

const LOW_CREDIT = 'Low credit score';
const LOW_FUND = 'Not enough funds';
const COMPANY_STAGE = 'Too early stage of a company';
const DTI = 'Too high DTI';

export const REJECT_REASONS = [LOW_CREDIT, LOW_FUND, COMPANY_STAGE, DTI];
